import Bugsnag from '@bugsnag/js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { initBugsnag } from './bugsnag/init';
import { handleAndMonitorError } from './helpers';
import './i18n/InitLocales';
import './index.css';
import router from './router';
import { registerPreloadErrorReload } from './utils/registerPreloadErrorReload';

registerPreloadErrorReload();

// Uncaught errors and rejections are reported by Bugsnag's own auto-detection, which files them
// as unhandled with severity=error and back-fills the real stack frame. Reporting them here as
// well produced a second, handled event for every incident — two issues, two auto-filed stories.
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled promise rejection:', event.reason);

  // Prevent default browser behavior (console logging)
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (process.env.REACT_APP_ENV === 'local') {
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
} else {
  initBugsnag();
  const ErrorBoundary = Bugsnag?.getPlugin('react')?.createErrorBoundary(React);

  if (!ErrorBoundary) {
    handleAndMonitorError('Error while trying to initialize Bugsnag');
    throw new Error('Error while trying to initialize Bugsnag');
  }
  root.render(
    <ErrorBoundary>
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    </ErrorBoundary>
  );
}
